import type { TilesetConfigEntry } from "./tilesetConfigEntry";

export class TilesetConfig {
	private entries: Map<string, TilesetConfigEntry>;

	constructor(entries: TilesetConfigEntry[]) {
		this.entries = new Map();
		for (const entry of entries) {
			this.entries.set(entry.key, entry);
		}
	}

	getEntry(key: string): TilesetConfigEntry | null {
		return this.entries.get(key) ?? null;
	}

	getEntryOrPlaceholder(key: string): TilesetConfigEntry | null {
		const entry = this.entries.get(key);
		if (entry) return entry;

		console.warn(`TilesetConfig: no entry for key "${key}", falling back to placeholder`);
		return this.entries.get("placeholder") ?? null;
	}

	get size(): number {
		return this.entries.size;
	}
}
